import MainLayout from "../components/layouts/MainLayout";
import Hero from "../components/Hero";
import SectionVideo from "../components/sections/SectionVideo";
import Container from "../components/Container";
import SectionQuestions from "../components/sections/SectionQuestions";
import imageHeroDesktop from "../public/img/hero/about_desktop.jpg";
import imageHeroMobile from "../public/img/hero/about_mobile.jpg";
import imageFriendsDesktop from '../public/img/hero/friends_desktop.jpg';
import imageFriendsMobile from '../public/img/hero/friends_mobile.jpg';
import SectionFloating from "../components/sections/SectionFloating";
import {generateTitle} from "../helpers/meta";
import Head from "next/head";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import Title from "../components/Title";

export default function AboutUs() {
    const {locale} = useRouter();
    const {aboutUs: lang} = localized[locale];

    return (
        <MainLayout>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
            </Head>

            <SectionFloating scheme="about-us"/>

            <Hero direction="image-right"
                  imageDesktop={imageHeroDesktop}
                  imageMobile={imageHeroMobile}
                  className="relative items-end gap-6 md:gap-10 md:pt-5"
            >
                <div className="md:pb-10 accent-pink-800">
                    <div className="flex flex-col gap-5 md:gap-2.5">
                        <header>
                            <Title Elem="h1">
                                {lang.header.title.localize({emoji: '📝'})}
                            </Title>
                        </header>
                        <p className="leading-[1.5] md:leading-[1.8] max-w-[49ch]">
                            {lang.header.body}
                        </p>
                    </div>
                </div>
            </Hero>

            <SectionVideo smallPadding={true}>
                <div className="flex flex-col gap-7">
                    {lang.video.body.map((item, key) => {
                        return (
                            <p key={key} className="leading-[1.8] max-w-[45ch]">
                                {item}
                            </p>
                        )
                    })}
                </div>
            </SectionVideo>

            <Hero direction="image-right"
                  imageDesktop={imageFriendsDesktop}
                  imageMobile={imageFriendsMobile}
                  className="relative items-center gap-10 accent-pink-800"
                  mobileReverse={false}
            >
                <p className="leading-[1.8] max-w-[45ch]">
                    {lang.airport[0]}
                </p>
            </Hero>

            <Container className="relative md:text-center accent-pink-800 pt-10 pb-16 md:pt-24">
                <p className="mx-auto leading-[1.8] max-w-[65ch]">
                    {lang.airport[1]}
                </p>
            </Container>

            <SectionQuestions className="accent-pink-800">
                <Title>{lang.questions.title.localize({emoji: '💬'})}</Title>
            </SectionQuestions>
        </MainLayout>
    )
}
